/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react"
import * as React from "react"
import { GlobalError } from "../../components/Error/Error"
import { ErrorLogger } from "../../ErrorLogger"

interface ErrorBoundaryState {
	error: boolean
}

interface ErrorBoundaryProps {
	children: React.ReactNode
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props)
		this.state = { error: false }
	}

	componentDidCatch(error: Error, errorInfo: any): void {
		ErrorLogger.error(`Error Boundary caught error:`, error)
		ErrorLogger.info("Error Info", errorInfo)
	}

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { error: true }
	}

	render(): React.ReactNode {
		const { error } = this.state
		if (error) {
			return <GlobalError />
		}
		return this.props.children
	}
}
